import { CE_VIEW_RENDERED_PREVIEW_OPEN } from "@js/actions/studio/campaign_content_section/screen_view_rendered_preview.js";

import { newScreen, getContent } from "@js/helpers/state.js";

export default (state = {}, action) => {
  switch (action.type) {
    case CE_VIEW_RENDERED_PREVIEW_OPEN:
      let content = getContent(state, action.client_content_id);
      if (
        !content ||
        !content.preview_image.image_url ||
        content.preview_image.error_generation_id
      ) {
        return state;
      } else {
        return newScreen(state, "view_rendered_preview", {
          previewURL: content.preview_image.image_url,
        });
      }

    default:
      return state;
  }
};
